import React from 'react';
import Header from "Orgs/Header";
import { returnHomeKeyUp } from "../../../../utils/returnHomeBtn"


const NotFound = ({ history, hpu }) => (

	<div className="com-errorpage">
		<Header />
		<div className="error-main">
			<div className="dx-col">
				{!hpu && <header> Uh-oh!  </header>}
				{!hpu && <div className="header-info">
					Now this is embarrassing.
				</div>}
				
				{!hpu && <div className="header-accent"></div>}

				{hpu ? <div className="text-block">
				The page you are trying to access no longer exists.
				</div> : <div className="text-block">
					Looks like the page you were seeking isn&#8217;t where it was supposed to be. If you need to speak with someone on our end, call our customer help line at <strong><a href="tel:+1-888-978-5371" tabIndex="0">1-888-978-5371</a></strong>. Our team is available Mon-Fri 8 am to 8:30 pm ET.
				</div>}
				<div className="button-area return-home-btn" onKeyUp={returnHomeKeyUp(history)} onClick={() => history.push('/')}>

					{!hpu && <button className="secondary" tabindex="0">Return to AIG.com</button>}
				</div>
			</div>
		</div>
	</div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/atomic/pages/NotFound/NotFound.js